module.exports = __webpack_public_path__ + "img/twitter-praizist-PDNc3fFFrYk-unsplash.4467975d.jpg";